import React from 'react';

import { observer } from 'mobx-react';

import Header from './header';
import Footer from './footer';

import useLayoutInit from './use-layout-init';

const PageBase = observer((props: any) => {
  const { children, hasHeader = true, hasFooter = true } = props;

  useLayoutInit();

  return (
    <React.Fragment>
      {hasHeader && <Header />}
      {children}
      {hasFooter && <Footer />}
    </React.Fragment>
  );
});

export default PageBase;
